import type { MeResponse, RedeemInviteResponse } from "@edu/shared";

/**
 * Сессия на клиенте из ответа погашения ссылки.
 *
 * Общая у ДВУХ экранов: погашения приглашения (`JoinPage`) и ссылки на одно
 * занятие (`room/lesson-link-gate.tsx`). Вынесена, а не скопирована, потому что
 * именно в этой сборке уже терялись поля: копия однажды отстала бы от
 * оригинала, и ученик снова увидел бы сайдбар преподавателя.
 *
 * Токен и имя преподавателя из ответа сюда не кладутся: состояние сессии
 * живёт дольше экрана, а токену в нём делать нечего.
 */
export function redeemedMe(session: RedeemInviteResponse): MeResponse {
  return {
    userId: session.userId,
    displayName: session.displayName,
    claimed: session.claimed,
    createdAt: session.createdAt,
    sessionExpiresAt: session.sessionExpiresAt,
    /**
     * Пояс переносим по той же причине, что и стороны пар: без него полоса
     * кабинета попросила бы подтвердить пояс у человека, который его уже
     * подтвердил, и записала бы догадку браузера поверх его значения.
     */
    ...(session.timeZone === undefined ? {} : { timeZone: session.timeZone }),
    /**
     * ⚠️ Стороны пар переносим обязательно. Этот объект и есть сессия на
     * клиенте до первой перезагрузки, и без них человек, только что
     * погасивший ссылку, видел бы сайдбар преподавателя: «Ученики»,
     * «Заготовки» и «Материалы», ручки которых отвечают ему 404. Проверено на
     * стенде: ровно так это и выглядело.
     *
     * exactOptionalPropertyTypes: поле либо есть со значением, либо его нет.
     */
    ...(session.teaching === undefined ? {} : { teaching: session.teaching }),
    ...(session.learning === undefined ? {} : { learning: session.learning }),
    /**
     * ⚠️ Признак неполной сессии переносим по той же причине, что пояс: без
     * него кабинет до перезагрузки ставил бы окно пояса и предлагал подпись на
     * доске сессии, которой сервер ответит `session_partial` (9.6
     * `docs/account-adopt-design.md`). Погашение ссылки второго преподавателя
     * как раз и выдаёт такую сессию на втором устройстве.
     */
    ...(session.sessionPartial === undefined ? {} : { sessionPartial: session.sessionPartial }),
    /**
     * ⚠️ Право звонков с преподавателями переносим по той же причине: без него
     * у держателя права, погасившего в этом браузере ссылку ученика (проверить,
     * как она работает), кнопка звонка в «Уроках» пропадала бы до перезагрузки.
     * Сервер присылает его только полной сессии, и только `true`.
     */
    ...(session.teacherCalls === undefined ? {} : { teacherCalls: session.teacherCalls }),
  };
}
